import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class ContractsHttpService {

  public static ALL_CONTRACTS_URL = DevelopUtil.url('leaseContract');
  public static CONTRACT_FILES_URL = DevelopUtil.url('leaseContract/attach');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getContracts(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(ContractsHttpService.ALL_CONTRACTS_URL, this.requestOptions);
  }

  getSingleContract(id, urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(ContractsHttpService.ALL_CONTRACTS_URL + '/' + id, this.requestOptions);
  }

  getPaginationContract(urlSearchParams: URLSearchParams): Observable<Response> {
      this.requestOptions.search = urlSearchParams;
      return this.http.get(ContractsHttpService.ALL_CONTRACTS_URL + '/count', this.requestOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contracts/contracts.http.service.ts